<template>
  <div>
    <div class="container index-container td-admin-container">
      <div class="section">
        <!--   Icon Section   -->
        <div class="row">
          <h1> Welcome to Administration Panel </h1>
        </div>
    
      </div>
      <br><br>
    </div>
  </div>
</template>

<script>
    export default {
        name: "IndexPage",
        // mounted() {
        //     fetch("https://instfenix.ru/api/get-calendar-events", {
        //         method: "POST",
        //         headers: {
        //             "Content-Type": "application/json"
        //         },
        //         body: {}
        //     })
        //         .then(function (response) {
        //             return response.json();
        //         })
        //         .then(function (response) {
        //             // eslint-disable-next-line no-console
        //             console.log(response);
        //         });
        // }
    }
</script>

<style scoped>

</style>